import Vue, { VueConstructor } from 'vue'

const assign = (target: object, source: any): void => {
   for (const prop in source) {
      if (prop[0] !== '$') {
         Vue.set(target, prop, source[prop])
      }
   }
}

const dynamicAssignPlugin = {
   install(vue: VueConstructor, options: any) {
      vue.prototype.$assign = assign
      vue.$assign = assign
   },
}

export default dynamicAssignPlugin
